import type { CoverageStatus } from '@/modules/projects/components/StatementCoverage/types'
import { emptyMonthClass } from '@/modules/projects/components/Workbench/coverage'
import {
  DROPPING_ON,
  TARGET_UNDER_POINTER,
} from '@/modules/projects/components/Workbench/mapView'
import { cn } from '@/utils'
import { AddMark } from './AddMark'
import { MissingWord } from './MissingWord'

export const cellContent = (coverage: CoverageStatus | null) => {
  if (!coverage) return <AddMark />
  return coverage === 'missing' ? <MissingWord /> : null
}

export const cellClass = (choosing: boolean, coverage: CoverageStatus | null) =>
  cn(
    'group/cell size-full cursor-pointer rounded-md border text-xs leading-none transition-colors',
    coverage
      ? emptyMonthClass(coverage)
      : 'border-border text-ink-subtle hover:bg-neutral-200 hover:text-foreground',
    choosing && TARGET_UNDER_POINTER,
    DROPPING_ON,
  )
